module.exports = __webpack_public_path__ + "static/media/6.85965896.png";